const NicaraguaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112017)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z"
        fill="#338AF3"
      />
      <path
        d="M19.9998 39.9997C27.929 39.9997 34.7803 35.3852 38.0153 28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997Z"
        fill="#338AF3"
      />
      <path
        d="M20.0005 13.9131C16.6388 13.9131 13.9136 16.6383 13.9136 20C13.9136 23.3618 16.6388 26.087 20.0005 26.087C23.3622 26.087 26.0875 23.3618 26.0875 20C26.0875 16.6383 23.3622 13.9131 20.0005 13.9131ZM20.0005 23.4783C18.0796 23.4783 16.5222 21.9211 16.5222 20C16.5222 18.0789 18.0795 16.5218 20.0005 16.5218C21.9215 16.5218 23.4788 18.0789 23.4788 20C23.4788 21.9211 21.9215 23.4783 20.0005 23.4783Z"
        fill="#FFDA44"
      />
      <path
        d="M23.0126 20.8695L20.0003 20L16.9879 20.8695L15.9839 22.6087H24.0166L23.0126 20.8695Z"
        fill="#0052B4"
      />
      <path
        d="M19.9999 15.6514L17.9917 19.1296L19.9999 19.9992L22.0081 19.1296L19.9999 15.6514Z"
        fill="#338AF3"
      />
      <path d="M16.9878 20.8689H23.0125L22.0083 19.1299H17.9919L16.9878 20.8689Z" fill="#6DA544" />
    </g>
    <defs>
      <clipPath id="clip0_4152_112017">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NicaraguaSvg;
